'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_SimpleSample$package$Cat$1(name, weight, hairsCount, kind) {
  this.ta = null;
  this.tb = 0;
  this.t8 = null;
  this.t9 = false;
  this.ta = name;
  this.tb = weight;
  this.t8 = hairsCount;
  this.t9 = kind;
}
export { $c_Lsamples_SimpleSample$package$Cat$1 as $c_Lsamples_SimpleSample$package$Cat$1 };
$p = $c_Lsamples_SimpleSample$package$Cat$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_SimpleSample$package$Cat$1;
/** @constructor */
function $h_Lsamples_SimpleSample$package$Cat$1() {
}
export { $h_Lsamples_SimpleSample$package$Cat$1 as $h_Lsamples_SimpleSample$package$Cat$1 };
$h_Lsamples_SimpleSample$package$Cat$1.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  var acc = (-889275714);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, 67510);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.ta));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, this.tb);
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, $j_java$002elang$002e$002dObject.$m_sr_Statics$().D(this.t8));
  acc = $j_java$002elang$002e$002dObject.$m_sr_Statics$().t(acc, (this.t9 ? 1231 : 1237));
  return $j_java$002elang$002e$002dObject.$m_sr_Statics$().an(acc, 4);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lsamples_SimpleSample$package$Cat$1)) {
    if ((((this.tb === x$0.tb) && (this.t9 === x$0.t9)) && (this.ta === x$0.ta))) {
      var x = this.t8;
      var x$2 = x$0.t8;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 4;
});
$p.o = (function() {
  return "Cat";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.ta;
      break;
    }
    case 1: {
      return this.tb;
      break;
    }
    case 2: {
      return this.t8;
      break;
    }
    case 3: {
      return this.t9;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__I__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lsamples_SimpleSample$package$Cat$1(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.et)));
}
export { $isArrayOf_Lsamples_SimpleSample$package$Cat$1 as $isArrayOf_Lsamples_SimpleSample$package$Cat$1 };
var $d_Lsamples_SimpleSample$package$Cat$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_SimpleSample$package$Cat$1, "samples.SimpleSample$package$Cat$1", ({
  et: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lsamples_SimpleSample$package$Cat$1 as $d_Lsamples_SimpleSample$package$Cat$1 };
